import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import { ContactHero, ContactSection } from '../components/ContactPageSections';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Contact Us - Electrician Carrum & Bayside"
        description="Contact Securelec for electrical and security services in Carrum and Bayside Melbourne. Call Mick or Tom, or send us an enquiry online."
        keywords="contact electrician Carrum, electrical enquiry Bayside Melbourne, security quote Carrum, Securelec contact"
        canonical="https://securelec.net.au/contact"
      />
      <Header />
      <main>
        <ContactHero />
        <ContactSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
